var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.292 47.25L37.5045 37.4625M24.792 13.5C31.0052 13.5 36.042 18.5368 36.042 24.75M42.792 24.75C42.792 34.6911 34.7331 42.75 24.792 42.75C14.8509 42.75 6.79199 34.6911 6.79199 24.75C6.79199 14.8089 14.8509 6.75 24.792 6.75C34.7331 6.75 42.792 14.8089 42.792 24.75Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth04);
export default __webpack_public_path__ + "static/media/health04.dc94979558a98c58b18a036b46d0c63a.svg";
export { ForwardRef as ReactComponent };